/* eslint-disable import/prefer-default-export */
import { schema } from 'normalizr';

export const occasionPrimaryCategoriesEntity = new schema.Entity(
  'occasionPrimaryCategories'
);
